import { styled } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { SearchIcon } from '../../../icons/SearchIcon.js';
import SearchInput from '../SearchBar.js';

var NavButton = styled('div')({
    height: 44,
    width: 44,
    minWidth: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    img: {
        maxHeight: 22,
        maxWidth: 22,
    },
});
var SearchBarContainer = styled('div')({
    //   position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    flex: 1,
    transition: 'all 0.5s ease',
    '&.open': {
        paddingRight: '10%',
    },
});
var SearchBar = styled('div')({
    width: 44,
    maxWidth: '100%',
    backgroundColor: brandclub_colors.white,
    display: 'flex',
    alignItems: 'center',
    '&.open': {
        backgroundColor: brandclub_colors.blueWhite,
        borderRadius: 300,
        paddingLeft: 10,
        paddingRight: 10,
        width: Math.min(window.innerWidth * 0.6 - 20, 810),
        transition: 'all 0.5s ease',
        zIndex: 1400,
    },
});
var Dummy = styled('div')({
    flex: 'auto',
    transition: 'flex 1s ease',
    '&.open': {
        flex: 0,
    },
});
var NavSearchButton = function (_a) {
    var searchInput = _a.searchInput, setSearchInput = _a.setSearchInput, handleClick = _a.handleClick, _b = _a.open, open = _b === void 0 ? false : _b, axios = _a.axios, useNavigate = _a.useNavigate, useSearchParams = _a.useSearchParams, persistentQueryParams = _a.persistentQueryParams, pageContext = _a.pageContext, mainEntity = _a.mainEntity, brandEntity = _a.brandEntity, filterDialogOpen = _a.filterDialogOpen, setFilterDialogOpen = _a.setFilterDialogOpen, filterCount = _a.filterCount, setFilterCount = _a.setFilterCount, onSubmitSearch = _a.onSubmitSearch, onClose = _a.onClose, routePrefix = _a.routePrefix;
    return (React.createElement(SearchBarContainer, { className: open ? 'open' : '' },
        React.createElement(Dummy, { className: open ? 'open' : '' }),
        React.createElement(SearchBar, { className: open ? 'open' : '' },
            React.createElement(NavButton, { onClick: handleClick },
                React.createElement(SearchIcon, { color: "primary" })),
            open ? (React.createElement(SearchInput, { onSubmit: onSubmitSearch, searchInput: searchInput, setSearchInput: setSearchInput, axios: axios, useNavigate: useNavigate, useSearchParams: useSearchParams, persistentQueryParams: persistentQueryParams, pageContext: pageContext, mainEntity: mainEntity, brandEntity: brandEntity, filterDialogOpen: filterDialogOpen, setFilterDialogOpen: setFilterDialogOpen, filterCount: filterCount, setFilterCount: setFilterCount, onClose: onClose, routePrefix: routePrefix })) : null)));
};

export { NavButton, NavSearchButton as default };
//# sourceMappingURL=NavSearchButton.js.map
